import { keyframes } from '@mui/material/styles';

// The entrance shared by every card on the educators home page.
export const FADE_IN_UP = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
`;

export const FADE_IN_UP_DURATION = '0.4s';
